import { useState, type FormEvent } from 'react';

const SUBMIT_ADDR = 'https://readdy.ai/api/form/db52fg8op8h4ruqk273g';

export default function SubscribeBand() {
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    const honeypot = String(formData.get('website_alt') || '').trim();
    if (honeypot) {
      setStatus('success');
      setFormError('');
      return;
    }
    formData.delete('website_alt');

    const params = new URLSearchParams();
    formData.forEach((value, key) => {
      params.append(key, String(value));
    });

    setStatus('loading');
    setFormError('');
    try {
      const response = await fetch(SUBMIT_ADDR, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });
      const responseText = await response.text();
      let parsed: { code?: string; message?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '';
      const isSpam = typeof serverMsg === 'string' && serverMsg.toLowerCase().includes('spam');

      if (response.ok && parsed?.code === 'OK' && !isSpam) {
        setStatus('success');
        form.reset();
      } else {
        setStatus('error');
        setFormError(serverMsg || '提交失败，请稍后再试');
      }
    } catch {
      setStatus('error');
      setFormError('网络异常，请稍后重试');
    }
  };

  return (
    <section id="subscribe" className="scroll-mt-24 bg-background-50 py-10 md:py-14">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="relative overflow-hidden rounded-lg bg-primary-600 px-6 py-8 md:px-10 md:py-10">
          <div className="absolute -top-16 -right-10 w-64 h-64 rounded-full bg-primary-400/40 blur-3xl" />
          <div className="absolute -bottom-20 left-10 w-56 h-56 rounded-full bg-accent-400/25 blur-3xl" />

          <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
            <div className="lg:col-span-6 text-background-50">
              <span className="inline-flex items-center gap-2 text-xs font-medium bg-background-50/15 border border-background-50/25 px-3 py-1.5 rounded-full">
                <i className="ri-mail-send-line" />
                每周一期，绝不打扰
              </span>
              <h2 className="mt-4 text-2xl md:text-3xl font-black leading-tight">
                订阅「青苹果片单」
                <br />
                每周五收到 5 部合你口味的青春片
              </h2>
              <p className="mt-3 text-sm text-background-100/90 max-w-md leading-relaxed">
                留下邮箱和你的偏好，我们按校园片、初恋电影、小清新帮你挑，从此不再纠结晚上看什么。
              </p>
            </div>

            <div className="lg:col-span-6">
              <form
                onSubmit={handleSubmit}
                data-readdy-form
                className="bg-background-50 rounded-lg p-5"
                noValidate
              >
                <div className="flex flex-col sm:flex-row gap-3">
                  <input
                    type="email"
                    name="email"
                    required
                    placeholder="你的邮箱地址"
                    className="flex-1 h-12 px-4 rounded-md bg-background-100 border border-background-200 text-sm text-foreground-800 placeholder:text-foreground-500 focus:outline-none focus:border-primary-400"
                  />
                  <select
                    name="preferred_genre"
                    defaultValue="校园片"
                    className="h-12 px-3 rounded-md bg-background-100 border border-background-200 text-sm text-foreground-800 focus:outline-none focus:border-primary-400"
                  >
                    <option value="校园片">偏好：校园片</option>
                    <option value="初恋电影">偏好：初恋电影</option>
                    <option value="小清新">偏好：小清新</option>
                    <option value="治愈系">偏好：治愈系</option>
                    <option value="青春怀旧">偏好：青春怀旧</option>
                  </select>
                </div>

                <input
                  type="text"
                  name="website_alt"
                  className="hp-field-holder"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                />

                <button
                  type="submit"
                  disabled={status === 'loading'}
                  className="mt-3 w-full h-12 rounded-md bg-accent-500 text-background-50 text-sm font-semibold hover:bg-accent-600 disabled:opacity-70 transition-colors whitespace-nowrap"
                >
                  {status === 'loading' ? '提交中…' : '免费订阅片单'}
                </button>

                {status === 'success' && (
                  <p className="mt-3 text-xs text-primary-700 bg-primary-50 border border-primary-200 rounded-md px-3 py-2">
                    <i className="ri-checkbox-circle-line mr-1" />
                    订阅成功！下一期片单会准时发到你的邮箱。
                  </p>
                )}
                {status === 'error' && (
                  <p className="mt-3 text-xs text-accent-700 bg-accent-50 border border-accent-200 rounded-md px-3 py-2">
                    <i className="ri-error-warning-line mr-1" />
                    {formError || '提交失败，请稍后再试'}
                  </p>
                )}
                {status === 'idle' && (
                  <p className="mt-3 text-xs text-foreground-500">
                    我们尊重隐私，仅用于发送片单推荐，可随时退订。
                  </p>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}